var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddGroupHover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0075ff;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,16C0,24.84,7.16,32,16,32s16-7.16,16-16S24.84,0,16,0,0,7.16,0,16Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.02,14.58h-1.22v-1.22c0-.34-.27-.61-.61-.61s-.61,.27-.61,.61v1.22h-1.22c-.34,0-.61,.27-.61,.61s.27,.61,.61,.61h1.22v1.22c0,.34,.27,.61,.61,.61s.61-.27,.61-.61v-1.22h1.22c.34,0,.61-.27,.61-.61s-.27-.61-.61-.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 9.75,
    cy: 13.57,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.76,17.01h2.99c-.96,1.1-2,2.72-2.15,4.06h-3.55c-.37,0-.68-.3-.68-.68,0-1.87,1.52-3.38,3.38-3.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.78,17.22h-2.57c-2.43,0-4.4,1.97-4.4,4.4,0,.49,.39,.88,.88,.88h9.62c.49,0,.88-.39,.88-.88,0-2.43-1.97-4.4-4.4-4.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16.49,
    cy: 12.75,
    r: 3.25
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGroupHover);
export default __webpack_public_path__ + "static/media/add-group-hover.e24d0115097f8819c433257ea1ee555a.svg";
export { ForwardRef as ReactComponent };